import { useState } from "react";
import { Link } from "react-router-dom";
import { Question } from "@phosphor-icons/react";

// Inline help button -> links to /help/:page
export function HelpInline({ page, label = "Aiuto" }) {
  return (
    <Link to={`/help/${page}`} className="btn-ghost text-xs inline-flex items-center gap-1" data-testid={`help-${page}`}>
      <Question size={14} weight="duotone" /> {label}
    </Link>
  );
}

// Global header search
export function GlobalSearch({ api }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [res, setRes] = useState({ tenders: [], partners: [] });
  const [loading, setLoading] = useState(false);

  const search = async (val) => {
    setQ(val);
    if (val.length < 2) { setRes({ tenders: [], partners: [] }); return; }
    setLoading(true);
    try {
      const { data } = await api.get(`/search?q=${encodeURIComponent(val)}`);
      setRes(data);
      setOpen(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative" data-testid="global-search">
      <input
        value={q} onChange={(e) => search(e.target.value)} onFocus={() => q.length > 1 && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
        placeholder="Cerca gare, partner..." className="input-field text-sm w-60" data-testid="global-search-input"
      />
      {open && (res.tenders.length > 0 || res.partners.length > 0) && (
        <div className="absolute top-full mt-1 right-0 w-80 bg-white border border-zinc-300 shadow-lg z-50 max-h-96 overflow-y-auto" data-testid="global-search-results">
          {res.tenders.length > 0 && (
            <>
              <div className="label-up px-3 py-2 bg-zinc-50 border-b">Gare</div>
              {res.tenders.map((t) => (
                <Link key={t.id} to={`/tenders/${t.id}`} className="block px-3 py-2 hover:bg-zinc-50 text-sm border-b border-zinc-100 last:border-0">
                  <div className="font-medium truncate">{t.title}</div>
                  <div className="text-xs text-zinc-500 font-mono">{t.portal} • {t.cig || "—"}</div>
                </Link>
              ))}
            </>
          )}
          {res.partners.length > 0 && (
            <>
              <div className="label-up px-3 py-2 bg-zinc-50 border-b border-t">Partner</div>
              {res.partners.map((p) => (
                <Link key={p.id} to="/partners" className="block px-3 py-2 hover:bg-zinc-50 text-sm border-b border-zinc-100 last:border-0">
                  <div className="font-medium">{p.name}</div>
                  <div className="text-xs text-zinc-500 font-mono">{p.vat}</div>
                </Link>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}
